import React from "react";
import { Navigate } from "react-router-dom";

//Users
const CrmUsers = React.lazy(() => import("../pages/Crm/CrmUsers"));
const UsersInfo = React.lazy(() => import("../pages/Crm/UsersInfo"));
const EmployeesInfo = React.lazy(() => import("../pages/Crm/EmployeesInfo"));

//Companies
const Companies = React.lazy(() => import("../pages/Companies/Companies"));

//Containers
//const Containers = React.lazy(() => import("../pages/Containers/index"));
const Containers = React.lazy(() => import("../pages/Containers/Registration"));
const AdditionalFees = React.lazy(() => import("../pages/AdditionalFees/index"));
const VFCalculation = React.lazy(() => import("../pages/Containers/VFCalculation"));
//const Warehouse = React.lazy(() => import("../pages/Containers/Warehouse"));

const Warehouse = React.lazy(() => import("../pages/Warehouses/index"));
const WarehouseIn = React.lazy(() => import("../pages/Warehouses/WarehouseIn"));
const WarehouseOut = React.lazy(() => import("../pages/Warehouses/WarehouseOut"));
const WarehouseSummary = React.lazy(() => import("../pages/Warehouses/WarehouseSummary"));
const TempWarehouse = React.lazy(() => import("../pages/Warehouses/TempWarehouse"));

//Print Container
const PrintContainer = React.lazy(() => import("../pages/Print/index"));
const PrintVFeesContainer = React.lazy(() => import("../pages/Print/vfees"));
const PrintReceiversContainer = React.lazy(() => import("../pages/Print/receivers"));
const PrintInvoicesContainer = React.lazy(() => import("../pages/Print/invoices"));
const PrintMInvoicesContainer = React.lazy(() => import("../pages/Print/minvoices"));
const PrintWInvoicesContainer = React.lazy(() => import("../pages/Print/winvoices"));
const PrintOrderInvoicesContainer = React.lazy(() => import("../pages/Print/oinvoices"));

//Dashboard
const DashboardContainers = React.lazy(() => import("../pages/DashboardContainers"));
const DashboardOrders = React.lazy(() => import("../pages/DashboardOrders"));

//Report
const Report = React.lazy(() => import("../pages/Report/VFeesStats"));
const Balance = React.lazy(() => import("../pages/Report/Balance"));

//Vehicles
const Vehicles = React.lazy(() => import("../pages/Vehicles"));
const ClientVehicles = React.lazy(() => import("../pages/Vehicles"));

//Orders
const Orders = React.lazy(() => import("../pages/Orders/index"));
const Tracking = React.lazy(() => import("../pages/Orders/indexTracking"));
const OrdersCompanies = React.lazy(() => import("../pages/Orders/OrdersCompanies"));
const Quotes = React.lazy(() => import("../pages/Quotes/index"));
const WebQuotation = React.lazy(() => import("../pages/Quotes/indexWQ"));
const FRTransactions = React.lazy(() => import("../pages/Orders/indexFRTransactions"));
const ClientTracking = React.lazy(() => import("../pages/Orders/indexClient"));

const CustomClearances = React.lazy(() => import("../pages/Invoices/CustomClearances"));
const CustomDeclarations = React.lazy(() => import("../pages/Invoices/CustomDeclarations"));

//Other Logistics
const LContainers = React.lazy(() => import("../pages/Containers/logistics"));
const BrokerReg = React.lazy(() => import("../pages/Containers/BrokerReg"));

//Clients
const ClientContainers = React.lazy(() => import("../pages/Containers/ClientContainers"));
const VFeesStatsClient = React.lazy(() => import("../pages/Report/client"));
const VFBalanceClient = React.lazy(() => import("../pages/Report/BalanceClient"));

//Invoices
const WarehouseInvoices = React.lazy(() => import("../pages/Invoices/WarehouseInvoices"));
const MainInvoices = React.lazy(() => import("../pages/Invoices/MainInvoices"));
const OrderInvoices = React.lazy(() => import("../pages/Invoices/OrderInvoices"));

const Alt404 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Alt404"));

//login
const Login = React.lazy(() => import("../pages/Authentication/Login"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));

// Landing Index
const OnePage = React.lazy(() => import("../pages/Landing/OnePage"));

//const SimplePage = React.lazy(() => import("../pages/Profile/SimplePage/SimplePage"));
const Settings = React.lazy(() => import("../pages/Profile/Settings/Settings"));

const Documents = React.lazy(() => import("../pages/Documents"));

const Archive = React.lazy(() => import("../pages/Documents/Archive"));

const Requests = React.lazy(() => import("../pages/Requests"));

const ClientsRequests = React.lazy(() => import("../pages/Requests/ClientsRequests"));

const LandingPage = React.lazy(() => import("../pages/LandingPage/index"));

export const getAuthProtectedRoutes = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const role = user?.role;
  const type = user?.type;
  const company = user?.company;
  const department = user?.department;
  const section = user?.section;

  if (!user || !user.accessToken) {
    return [
      {
        path: "*",
        component: <Navigate to="/login" />,
      },
    ];
  }

  return [
    //CrmUsers
    ...(role === "Админ" || role === "Гүйцэтгэх захирал"
      ? [{ path: "/users", component: <CrmUsers /> }]
      : [{ path: "/users", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга"
      ? [{ path: "/employees", component: <EmployeesInfo /> }]
      : [{ path: "/employees", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан" ||
      role === "ТГЗ"
      ? [{ path: "/documents", component: <Documents /> }]
      : [{ path: "/documents", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан" ||
      role === "ТГЗ"
      ? [{ path: "/archive", component: <Archive /> }]
      : [{ path: "/archive", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Захиргаа удирдлага, санхүүгийн газрын захирал" ||
      role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
      role === "Архив, бичиг хэргийн ажилтан"
      ? [{ path: "/requests", component: <Requests /> }]
      : [{ path: "/requests", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "ТГЗ" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/dashboard", component: <DashboardContainers /> }]
      : [{ path: "/dashboard", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      role === "ТГЗ" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/dashboard-orders", component: <DashboardOrders /> }]
      : [
        { path: "/dashboard-orders", component: <Navigate to="/tracking" /> },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      role === "ТГЗ" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/oinvoices", component: <OrderInvoices /> }]
      : [{ path: "/oinvoices", component: <Navigate to="/tracking" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // role === "ТГЗ" ||
    // section === "Санхүүгийн хэлтэс"
    //   ? [{ path: "/oinvoices/:id", component: <PrintOrderInvoicesContainer /> }]
    //   : [{ path: "/oinvoices/:id", component: <Navigate to="/tracking" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      role === "ТГЗ"
      ? [{ path: "/fees", component: <VFCalculation /> }]
      : [{ path: "/fees", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      role === "ТГЗ"
      ? [{ path: "/warehouse", component: <Warehouse /> }]
      : [{ path: "/warehouse", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/warehousein", component: <WarehouseIn /> }]
      : [
        { path: "/warehousein", component: <Navigate to="/user-settings" /> },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/warehouseout", component: <WarehouseOut /> }]
      : [
        {
          path: "/warehouseout",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/warehousereport", component: <WarehouseSummary /> }]
      : [
        {
          path: "/warehousereport",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГТА/" ||
      role === "ТГЗ"
      ? [{ path: "/tempwarehouse", component: <TempWarehouse /> }]
      : [
        {
          path: "/tempwarehouse",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      role === "ТГЗ"
      ? [{ path: "/vfreport", component: <Report /> }]
      : [{ path: "/vfreport", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/balance", component: <Balance /> }]
      : [{ path: "/balance", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/invoices", component: <WarehouseInvoices /> }]
      : [{ path: "/invoices", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/minvoices", component: <MainInvoices /> }]
      : [{ path: "/minvoices", component: <Navigate to="/user-settings" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Терминалын газрын захирал" ||
    // role === "Товарын хэлтсийн дарга" ||
    // section === "Санхүүгийн хэлтэс" ||
    // role === "ТГЗ"
    //   ? [{ path: "/minvoices/:id", component: <PrintMInvoicesContainer /> }]
    //   : [
    //       {
    //         path: "/minvoices/:id",
    //         component: <Navigate to="/user-settings" />,
    //       },
    //     ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "ТГЗ"
      ? [{ path: "/vehicles", component: <Vehicles /> }]
      : [{ path: "/vehicles", component: <Navigate to="/containers" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/companies", component: <Companies /> }]
      : [{ path: "/companies", component: <Navigate to="/containers" /> }]),

    //Reference Information
    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/addfees", component: <AdditionalFees /> }]
      : [{ path: "/addfees", component: <Navigate to="/containers" /> }]),

    //Containers
    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Терминалын газрын захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Товарын хэлтсийн дарга" ||
      role === "Терминалын хэлтсийн дарга" ||
      role === "Кассир" ||
      role === "Механик инженер" ||
      role === "Ачаа вагон хүлээлцэгч" ||
      role === "Кранист" ||
      role === "ТГЗ" ||
      role === "Агуулахын эрхлэгч /ГБА/" ||
      section === "Санхүүгийн хэлтэс"
      ? [{ path: "/containers", component: <Containers /> }]
      : [{ path: "/containers", component: <Navigate to="/user-settings" /> }]),

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // section === "Санхүүгийн хэлтэс" ||
    // role === "ТГЗ"
    //   ? [{ path: "/orders", component: <Orders /> }]
    //   : [{ path: "/orders", component: <Navigate to="/" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/quotes", component: <Quotes /> }]
      : [{ path: "/quotes", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/wquotes", component: <WebQuotation /> }]
      : [{ path: "/wquotes", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/tracking", component: <Tracking /> }]
      : [{ path: "/tracking", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/frtransactions", component: <FRTransactions /> }]
      : [
        {
          path: "/frtransactions",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      role === "Тээврийн менежер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/lgcompanies", component: <OrdersCompanies /> }]
      : [
        { path: "/lgcompanies", component: <Navigate to="/user-settings" /> },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "Гаалийн брокер" ||
      role === "Талбайн брокер"
      ? [{ path: "/customclearances", component: <CustomClearances /> }]
      : [
        {
          path: "/customclearances",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" ||
      role === "Гүйцэтгэх захирал" ||
      role === "Тээврийн газрын захирал" ||
      role === "Тээврийн хэлтсийн дарга" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "Ахлах гаалийн бүртгэгдсэн мэргэжилтэн" ||
      role === "Гаалийн бүртгэгдсэн мэргэжилтэн"
      ? [{ path: "/customdeclarations", component: <CustomDeclarations /> }]
      : [
        {
          path: "/customdeclarations",
          component: <Navigate to="/user-settings" />,
        },
      ]),

    ...(role === "Админ" || company === "TILogistic"
      ? [{ path: "/crequests", component: <ClientsRequests /> }]
      : [{ path: "/crequests", component: <Navigate to="/user-settings" /> }]),

    ...(role === "Админ"
      ? [{ path: "/landing", component: <LandingPage /> }]
      : [{ path: "/settings", component: <Navigate to="/settings" /> }]),

    //User Profile
    //{ path: "/pages-profile", component: <SimplePage /> },
    { path: "/user-settings", component: <Settings /> },

    // ...(role === "Админ" ||
    // role === "Гүйцэтгэх захирал" ||
    // role === "Тээврийн газрын захирал" ||
    // role === "Тээврийн хэлтсийн дарга" ||
    // role === "Тээврийн менежер" ||
    // section === "Санхүүгийн хэлтэс" ||
    // role === "ТГЗ"
    //   ? [{ path: "/lcontainers", component: <LContainers /> }]
    //   : [{ path: "/lcontainers", component: <Navigate to="/" /> }]),

    ...(role === "Админ" ||
      role === "Гаалийн брокер" ||
      role === "Талбайн брокер" ||
      section === "Санхүүгийн хэлтэс" ||
      role === "ТГЗ"
      ? [{ path: "/bcontainers", component: <BrokerReg /> }]
      : [{ path: "/bcontainers", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч" ||
      department === "Тээврийн газар"
      ? [{ path: "/client-containers", component: <ClientContainers /> }]
      : [{ path: "/client-containers", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч"
      ? [{ path: "/vfclient", component: <VFeesStatsClient /> }]
      : [{ path: "/vfclient", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч"
      ? [{ path: "/vfcalc", component: <VFBalanceClient /> }]
      : [{ path: "/vfcalc", component: <Navigate to="/" /> }]),

    ...(type === "Терминалын газрын хэрэглэгч" ||
      department === "Тээврийн газар"
      ? [{ path: "/vhclient", component: <ClientVehicles /> }]
      : [{ path: "/vhclient", component: <Navigate to="/" /> }]),

    ...(type === "Тээврийн газрын хэрэглэгч"
      ? [{ path: "/client-tracking", component: <ClientTracking /> }]
      : [{ path: "/client-tracking", component: <Navigate to="/" /> }]),

    //{ path: "/client-containers", component: <ClientContainers /> },
    //{ path: "/vfclient", component: <VFeesStatsClient /> },
    //{ path: "/vfcalc", component: <VFBalanceClient /> },
    //{ path: "/vhclient", component: <ClientVehicles /> },

    { path: "/auth-404-alt", component: <Alt404 /> },

    {
      path: "/",
      exact: true,
      component: <Navigate to="/user-settings" />,
    },
    { path: "*", component: <Navigate to="/user-settings" /> },
  ];
};

export const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  //Print Containers
  { path: "/print/:id", component: <PrintContainer /> },
  { path: "/printvf/:id", component: <PrintVFeesContainer /> },
  { path: "/printrc/:id", component: <PrintReceiversContainer /> },
  { path: "/invoices/:id", component: <PrintInvoicesContainer /> },
  { path: "/minvoices/:id", component: <PrintMInvoicesContainer /> },
  { path: "/oinvoices/:id", component: <PrintOrderInvoicesContainer /> },
  { path: "/winvoices/:id", component: <PrintWInvoicesContainer /> },

];
